import { Autocomplete, Backdrop, Box, Button, Checkbox, CircularProgress, Divider, FormControl, FormControlLabel, Grid, IconButton, Paper, Radio, RadioGroup, Switch, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography } from '@mui/material';
import { useFormik } from 'formik';
import React, { useEffect, useState } from 'react';
import * as yup from 'yup';
import CustomDataGrid from '../../../../../components/dataTable/customDataGrid';
import CustomdropDown from '../../../../../components/utils/dropDown/customdropDown';
import CustomTextField from '../../../../../components/utils/input/customTextField';
import Modal from '../../../../../components/utils/modal/modal';
import { useDispatch } from 'react-redux';
import axios from 'axios';
import { setSnackbar } from '../../../../../components/hooks/snackBar/reducers';
import _  from 'lodash';
import EditNoteIcon from '@mui/icons-material/EditNote'
import DeleteIcon from '@mui/icons-material/Delete'
import DeletePage from '../../../../../components/utils/deleteModal/deletePage';
import { Helmet } from 'react-helmet-async';
import PrintComponent from '../../../../../components/utils/print/PrintComponent';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import moment from 'moment';
import dayjs from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { Add } from '@mui/icons-material';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { Link } from 'react-router-dom';
import TypeDesignModal from './typedesignmodal';
import BrandModal from './brandModel';
import MainCategoryModal from './maincategorymodal';
import SubCategoryModal from './subCategorymodal';
import ProductMapping from '../../admin/outlet/productMapping';
import { useStyle } from '../style';

// import TypeDesign from './typedesign';
const initialNewData = {
  fullname: '',
  outlet_opng_stock: '',
  outlet_balnc_stock: '',
  outlet_min_stock: '',
  outlet_allow_neg_stk: false,
  outlet_wscale: false,
};
const Product = () => {
    const pageOption = [10, 25, 50, 100]
    const dispatch = useDispatch()
    const [page, setPage] = useState(0)
    const [rowsPerPage, setRowsPerPage] = useState(100);
    // const [rowsPerPage, setRowsPerPage] = useState(pageOption[0]);
    const [pageCount, setPageCount] = useState(0);
    const [search, setSearch] = useState('')
    const [open, setOpen] = useState(false)
    const [isEdit, setIsEdit] = useState(false)
    const [data, setData] = useState([])
    const [active, setActive] = useState(true)
    const [typeData , setTypeData] = useState([]) // type design data
    const [headData , setHeadData] = useState([]) // head data
    const [mainCatData , setMainCatData] = useState([]) // main cat data
    const [subCatData , setSubCatData] = useState([]) // sub cat data
    const [uomData , setUomCatData] = useState([]) // uom data
    const [cusData , setCusData] = useState([]) // customer data
    const [openDialog, setOpenDialog] = useState(false)
    const [opentypedesign, setOpenTypeDesign] = useState(false)
    const [opentypedesign1, setOpenTypeDesign1] = useState(false)
    const [openMainCategory, setOpenMainCategory] = useState(false)
    const [openSubCategory, setOpenSubCategory] = useState(false)
    const [activeId, setActiveId] = useState(null)
    const [outletData, setOutletData] = useState([])
    const [outletData1, setOutletData1] = useState([])
    const [outletToData, setOutletToData] = useState([])
    const [balance, setBalance] = useState('')
    const [isLoader, setIsLoader] = useState(false); //loader
    const [productDetails, setProductDetails] = useState({});
    const [fromOutlet, setFromOutlet] = useState(null);
    const [toOutlet, setToOutlet] = useState(null);
    const [openProduct, setOpenProduct] = useState(false)
    const [selectedOutlet, setSelectedOutlet] = useState(null);
    const [selectedOutletId, setSelectedOutletId] = useState(null);
    const [selectedOutletName, setSelectedOutletName] = useState('');
    const [closedStatus, setClosedStatus] = useState({}); 
    const [newData, setNewData] = useState(initialNewData);
    const classes = useStyle();
    const savedData = localStorage.getItem('typeData');
    const validationSchema = yup.object({
      productName : yup.string().required(),
      shortName:yup.string().notRequired(),
      productCode:yup.string().required(),
      productDisc:yup.string().notRequired(),
      typeDesign :yup.object().required(),
      head:  yup.object().required(),
      mainCategory:  yup.object().required(),
      subCategory:  yup.object().required(),
      uom:  yup.object().required(),
      barcode:yup.string().required(),
      purchaseRate: yup.string().required(),
      wholeSaleRate: yup.string().required(),
      salesRate: yup.string().required(),
      mrp: yup.string().required(),
      gst: yup.string().required(),
      cess: yup.string().required(),
      hsn: yup.string().required(),
      opStk: yup.string().required(),
      minStk: yup.string().required(),
      vendor: yup.array().min(1),
      allowNegStack:yup.string().required(),
      wScale:yup.string().required(),
      // isBatch:yup.string().required(),
      outlet: yup.array().min(1),
         purchaseRate: yup.number()
    .required("Purchase rate is required")
    .lessThan(yup.ref('salesRate'), "Purchase rate cannot be greater than sales rate")
    .lessThan(yup.ref('mrp'), "Purchase rate cannot be greater than MRP"), // Validate purchaseRate against mrp

    })
    
    const formik = useFormik({
      initialValues :{
        productName : "",
        shortName:"",
        productCode:"",
        productDisc:"",
        typeDesign : null,
        head : null,
        mainCategory : null,
        subCategory : null,
        uom : null,
        barcode : "-",
        purchaseRate : "",
        wholeSaleRate : "",
        salesRate : "",
        mrp : "",
        gst : "",
        cess : "0",
        hsn : "",
        opStk : "",
        minStk : "",
        vendor : [],
        allowNegStack: "",
        wScale:"",
        isBatch: "",
        outlet:[],
        fromoutlet: null,
      tooutlet: null,
      },
      validationSchema:validationSchema,
    onSubmit: isEdit ? handleUpdate : handleCreate
    })
    const [prodDate, setProdDate] = useState({
      manufactureDate : moment().format(),
      expiryDate : moment().format()
    })
    console.log(isEdit,"isEdit122");
    const handleEnterKey = async (e) => {
      if (e.key === 'Enter') {
        try {
          const response = await axios.post('/v1/Item/info/procode', {
            pro_code: formik.values.productCode,
          });
          if (response.data) {
            console.log(response.data, "API response");
    
            // Find matching objects from data arrays for dropdowns
            const matchingUOM = uomData.find(uom =>  response.data.uom_name);
            const matchingHead = headData.find(head => head.cateogory_name === response.data.head_name);
            const matchingMainCategory = mainCatData.find(cat => cat.category_name === response.data.cat_name);
            const matchingSubCategory = subCatData.find(subCat => subCat.subcategory_name === response.data.sub_cat_name);
            const matchingTypeDesign = typeData.find(type => type.type_name === response.data.type_name);
            const matchingVendors = response.data.vendors.map(vendorObj => 
              cusData.find(vendor => vendor.name === vendorObj.name)
            ).filter(Boolean);  // Filter out any undefined matches
            
            formik.setFieldValue("vendor", matchingVendors);  // Set the matched vendors in Formik
            
                // Auto-fill form fields with the API response
            formik.setValues({
              ...formik.values,
              productName: response.data.pro_name,
              productDisc: response.data.pro_description,
              shortName: response.data.short_name,
              uom: matchingUOM || '',  // Set matching UOM object or empty
              purchaseRate: response.data.pur_rate,
              salesRate: response.data.sale_rate,
              wholeSaleRate: response.data.wholesale_rate,
              mrp: response.data.mrp,
              gst: response.data.gst,
              cess: response.data.cess,
              hsn: response.data.hsn,
              opStk: response.data.op_stk,
              minStk: response.data.min_stock,
              allowNegStack: response.data.allow_neg_stk === true ? "Yes" : "No",
              wScale: response.data.wscale === true ?  "Yes" : "No",
              isBatch: response.data.isBatch === true ?  "Yes" : "No",
              mainCategory: matchingMainCategory || '',  // Set matching main category object
              subCategory: matchingSubCategory || '',  // Set matching subcategory object
              typeDesign: matchingTypeDesign || '',  // Set matching type design object
              head: matchingHead || '',  // Set matching head object
              vendor: matchingVendors, 
            });
          }
        } catch (error) {
          console.error('Error fetching product info:', error);
        }
      }
    };
    
    // const handleEnterKey = async (e) => {
    //   if (e.key === 'Enter') {
    //     try {
    //       const response = await axios.post('/v1/Item/info/procode', {
    //         pro_code: formik.values.productCode,
    //       });
    //       if (response.data) {
            
    //         // Auto-fill form fields with the API response
    //         setProductDetails(response.data);
    //         console.log(response.data,"responseresponse");
            
    //         formik.setValues({
    //           ...formik.values,
    //           productName: response.data.pro_name,
    //           productDisc: response.data.pro_description,
    //           shortName: response.data.short_name,
    //           uom: response.data.uom_name,
    //           purchaseRate: response.data.pur_rate,
    //           salesRate: response.data.sale_rate,
    //           wholeSaleRate:  response.data.wholesale_rate,
    //           mrp: response.data.mrp,
    //           gst: response.data.gst,
    //           cess: response.data.cess,
    //           hsn: response.data.hsn,
    //           opStk: response.data.op_stk,
    //           minStk: response.data.min_stock,
    //           allowNegStack: response.data.allow_neg_stk,
    //           wScale: response.data.wscale,
    //           mainCategory: response.data.cat_name,
    //           subCategory: response.data.sub_cat_name,
    //           typeDesign: response.data.type_name,
    //           // vendor: response.data.vendor,
    //           head: response.data.head_name,
    //           // fill other fields based on API response...
    //         });
    //       }
    //     } catch (error) {
    //       console.error('Error fetching product info:', error);
    //     }
    //   }
    // };
  
    function handleChange(e, name) {
      setProdDate(prev=>({...prev,[name] : dayjs(e).format() }))
    }
    // const onCreate = () => {
    //   setOpen(true)
    //   formik.resetForm()
    //   setIsEdit(false)
    // }
    function onCreate() {
      setOpen(true);
      formik.resetForm();
      formik.setFieldValue('outlet', outletData);  // Set all outlets as selected
      // formik.setFieldValue('vendor', cusData);     // Set all vendors as selected
      setIsEdit(false);
    }
    
    function handleCreate () {
      const outletArr = _.map(formik.values.outlet, val=>({
        outlet_id : val.id
      }))
      const vendorArr = _.map(formik.values.vendor,val=>({
        vendor_id : val.id
      }))

      //new
         // Ensure barcode_details is passed as an array
    const barcodes = Array.isArray(formik.values.barcode)
    ? formik.values.barcode
    : [formik.values.barcode];
  const barcodeDetails = barcodes.map(barcode => ({ barcode }));

  const tableData = formik.values.outlet.map((outlet, index) => ({
    fullname: outlet.fullname,
    outlet_opng_stock: Number(newData[`outlet_${index}_op_stock`] || 0), // Convert to number
    outlet_balnc_stock: Number(newData[`outlet_${index}_bal_stock`] || 0), // Convert to number
    // outlet_min_stock: Number(newData[`outlet_${index}_min_stock`] || 0), // Convert to number
    outlet_min_stock: parseFloat(Number(newData[`outlet_${index}_min_stock`] || 0).toFixed(0)),

    outlet_allow_neg_stk: newData[`outlet_${index}_allow_neg_stk`] || false,
    outlet_wscale: newData[`outlet_${index}_wscale`] || false,
    outlet_id: outlet.id,
  }));


      const itemsData = {
        pro_code:formik.values.productCode,
        short_name:formik.values.shortName,
        pro_name:formik.values.productName,
        pro_description:formik.values.productDisc,
        type:formik.values.typeDesign.id,
        sub_cat:formik.values.subCategory.id,
        company_id: 1,
        uom:formik.values.uom.id,
        barcode:formik.values.barcode,
        pur_rate:formik.values.purchaseRate,
        sale_rate:formik.values.salesRate,
        wholesale_rate:formik.values.wholeSaleRate,
        mrp:formik.values.mrp,
        gst:formik.values.gst,
        cess:formik.values.cess,
        hsn:formik.values.hsn,
        op_stk:formik.values.opStk,
        min_stock:formik.values.minStk,
        // allow_neg_stk:formik.values.allowNegStack === "Yes" ? true : false,
        wscale:formik.values.wScale === "Yes" ? true : false,
        is_batch:formik.values.isBatch === "Yes" ? true : false,
        vendors:vendorArr,
        is_active:active,
        cat_id: formik.values.mainCategory.id,
        head_id: formik.values.head.id,
        allow_neg_stock: formik.values.allowNegStack === 'Yes' ? true : false,
        // outlets: outletArr,
        outlets: tableData,
        manufacturing_date:moment(prodDate.manufactureDate).format('YYYY-MM-DD'),
        expiry_date:moment(prodDate.expiryDate).format('YYYY-MM-DD')
      }
    setIsLoader(true)
    axios.post('/v1/Item',itemsData)
    .then(res=>{
      setOpen(false)
      getItemsData()
      dispatch(setSnackbar(true, 'success','Created Successfully!'))
      setOpen(false)
      setIsLoader(false)
    })
    .catch(err=>{
      dispatch(setSnackbar(true,'error',err.response.data.errors[0].message))
      setIsLoader(false)
    })
    }
    function onEdit(e){
      formik.resetForm()
      console.log(e)
      setIsEdit(true)
      setOpen(true)
      setActiveId(e.id)
      setBalance(e.balance)
      
      const geteditrowdata = data.find(row=> row.id === e.id)
      // const getbarcode = geteditrowdata.barcode_list.map(code=>{ return{
      //   barcode: code.barcode
      // }})
      // formik.setFieldValue("barcode_details", getbarcode);
       // Create a newData object to prefill the table fields

         
 const newOutletData = {};

 // Loop through the outlets to prefill values
 e.outlets.forEach((outlet, index) => {
   newOutletData[`outlet_${index}_op_stock`] = outlet.outlet_opng_stock || '';
   newOutletData[`outlet_${index}_bal_stock`] = outlet.outlet_balnc_stock || '';
   newOutletData[`outlet_${index}_min_stock`] = outlet.outlet_min_stock || '';
   newOutletData[`outlet_${index}_allow_neg_stk`] = outlet.outlet_allow_neg_stk || false;
   newOutletData[`outlet_${index}_wscale`] = outlet.outlet_wscale || false;
 });

 // Update the state with the new data
 setNewData(newOutletData);

 //new
      formik.setFieldValue('productCode' , e.productCode)
      formik.setFieldValue('productName' , e.productName)
      formik.setFieldValue('shortName' , e.shortName)
      formik.setFieldValue('productDisc' , e.productDisc)
      setProdDate((prev) => ({...prev , manufactureDate:e.manufacturing_date , expiryDate:e.expiry_date}))
      typeData.filter(value => value.id === e.typeDesign_id).map(val => formik.setFieldValue('typeDesign' , val))
      headData.filter(value => value.id === e.head_id).map(val => formik.setFieldValue('head' , val))
      mainCatData.filter(value => value.id === e.category_id).map(val => formik.setFieldValue('mainCategory' , val))
      subCatData.filter(value => value.id === e.subCategory_id).map(val => formik.setFieldValue('subCategory' , val))
      uomData.filter(value => value.id === e.uom_id).map(val => formik.setFieldValue('uom' , val))
      // cusData.filter(value => value.id === e.vendor).map(val => formik.setFieldValue('vendor' , val))
      formik.setFieldValue('barcode' , e.barCode)
      formik.setFieldValue('purchaseRate' , e.purchaseRate)
      // formik.setFieldValue('salesRate' , e.salesRate)
      formik.setFieldValue('wholeSaleRate' , e.wholeSaleRate)
      formik.setFieldValue('mrp' , e.mrp)
      formik.setFieldValue('gst' , e.gst)
      formik.setFieldValue('cess' , e.cess)
      formik.setFieldValue('hsn' , e.hsn)
      formik.setFieldValue('opStk' , e.op_stk)
      formik.setFieldValue('minStk' , e.min_stock)
      formik.setFieldValue('wScale' ,e.wScale ? 'Yes' : 'No')
      formik.setFieldValue('isBatch' ,e.is_batch ? 'Yes' : 'No')
      formik.setFieldValue('allowNegStack' ,e.allow_neg_stock ? 'Yes' : 'No' )
      console.log(e.outlets , outletData)
//new
      const geteditrowdatas = data.find(row=> row.id === e.id)
      formik.setFieldValue('purchasetype', geteditrowdatas.product_type === 'purchase' ? 'Yes' : 'No');

      // formik.setFieldValue("barcode_details", getbarcode);

//new
      const outArr = e.outlets
      const filteredOutletData = outArr.map((outlet) => {
        const matchingOutlet = outletData.find((data) => data.id === outlet.id);
        // Return a new object combining properties from both arrays
        return {
          ...matchingOutlet,
        }
      })
      const vendArr = e.vendor
      const filteredVendorData = vendArr.map((outlet) => {
        const matchingVendor = cusData.find((data) => data.id === outlet.id);
        // Return a new object combining properties from both arrays
        return {
          ...matchingVendor,
        }
      })
      console.log(filteredOutletData)
      formik.setFieldValue('vendor', filteredVendorData)
      formik.setFieldValue('outlet', filteredOutletData)
    }
    function OnDelete(id){
      setOpenDialog(true)
      setActiveId(id)
    }  
    function OnclicktypeDesign(){
      setOpenTypeDesign(true)
      
    }
    function OnclickBrandDesign(){
      setOpenTypeDesign1(true)
      
    }
    function OnclickMainCatecory(){
      setOpenMainCategory(true)
    }
    function OnclickSubCatecory(){
      setOpenSubCategory(true)
    }
    function handleUpdate(){
      const outletArr = _.map(formik.values.outlet, val=>({
        outlet_id : val.id
      }))
      const vendorArr = _.map(formik.values.vendor,val=>({
        vendor_id : val.id
      }))
      const tableData = formik.values.outlet.map((outlet, index) => ({
        fullname: outlet.fullname,
        outlet_opng_stock: Number(newData[`outlet_${index}_op_stock`] || 0),  // Convert to number
        outlet_balnc_stock: Number(newData[`outlet_${index}_bal_stock`] || 0),  // Convert to number
        outlet_min_stock: Number(newData[`outlet_${index}_min_stock`] || 0),  // Convert to number
        outlet_allow_neg_stk: newData[`outlet_${index}_allow_neg_stk`] || false,
        outlet_wscale: newData[`outlet_${index}_wscale`] || false,
        outlet_id: outlet.id,
      }));

      const itemsData = {
        pro_code:formik.values.productCode,
        short_name:formik.values.shortName,
        pro_name:formik.values.productName,
        pro_description:formik.values.productDisc,
        type:formik.values.typeDesign.id,
        sub_cat:formik.values.subCategory.id,
        company_id: 1 ,
        uom:formik.values.uom.id,
        barcode:formik.values.barcode,
        pur_rate:formik.values.purchaseRate,
        sale_rate:formik.values.salesRate,
        wholesale_rate:formik.values.wholeSaleRate,
        mrp:formik.values.mrp,
        gst:formik.values.gst,
        cess:formik.values.cess,
        hsn:formik.values.hsn,
        op_stk:formik.values.opStk,
        min_stock:formik.values.minStk,
        // allow_neg_stk:formik.values.allowNegStack === "Yes" ? true : false,
        wscale:formik.values.wScale === "Yes" ? true : false,
        is_batch:formik.values.isBatch === "Yes" ? true : false,
        vendors: vendorArr,
        is_active:active,
        cat_id: formik.values.mainCategory.id,
        head_id: formik.values.head.id,
        allow_neg_stock: formik.values.allowNegStack === 'Yes' ? true : false,
        // outlets: outletArr,
        outlets: tableData,
        manufacturing_date:moment(prodDate.manufactureDate).format('YYYY-MM-DD'),
        expiry_date:moment(prodDate.expiryDate).format('YYYY-MM-DD')
      }
      setIsLoader(true)
    axios.put(`/v1/Item/${activeId}`,itemsData)
    .then(res=>{
      setOpen(false)
      getItemsData()
      dispatch(setSnackbar(true, 'success','Updated Successfully!'))
      setOpen(false)
      setIsLoader(false)
    })
    .catch(err=>{
      dispatch(setSnackbar(true,'error',err.response.data.errors[0].message))
      setIsLoader(false)
    
    })

    }
    const handleDelete = () =>{
      setIsLoader(true)
      axios.delete(`/v1/Item/${activeId}`)
      .then(res=>{
        console.log(res)
        getItemsData()
      dispatch(setSnackbar(true, 'success','Deleted Successfully!'))
      setIsLoader(false)
      setOpen(false)
      })
      .catch(err=>{
        console.log(err)
        dispatch(setSnackbar(true,'error',err.response.data.errors[0].message))
      setIsLoader(false)
      })
      setOpenDialog(false)
      setActiveId(null)
    }
    function OnAssignProduct(id,name){
      // const selectedOutlet = outletData.find(outlet => outlet.id === id);
      // setFromOutlet(selectedOutlet || null);
      formik.resetForm();
      setSelectedOutletName(name);
      setOpenProduct(true)
      setActiveId(id)
      setSelectedOutletId(id);
     
      setClosedStatus((prev) => ({
          ...prev,
          [id]: prev[id] !== undefined ? prev[id] : 0 // Default status to 0 (open)
      }));
  
      console.log(selectedOutlet,"selectedOutlet");
      
    }  
    const getTypeDesignData = () => {
      setIsLoader(true);
    
      axios.get("/v1/typedesign")
        .then((res) => {
          // Filter only active items
          const activeTypeData = res.data.filter((item) => item.is_active); 
          setTypeData(activeTypeData);
          console.log(activeTypeData, "Filtered active response");
    
          setIsLoader(false);
        })
        .catch((err) => {
          console.log(err);
          dispatch(setSnackbar(true, 'error', err.response.data.error));
          setIsLoader(false);
        });
    };

const getHeadData = () => {
  setIsLoader(true)

  axios.get("/v1/Head")
  .then((res) => {
    setHeadData(res.data)
    console.log(res.data,"headdata");
    
    setIsLoader(false)
  })
  .catch((err) => {
    console.log(err)
    dispatch(setSnackbar(true,'error',err.response.data.error))
    setIsLoader(false)
  })
}
const getMainCatData = () => {
  setIsLoader(true)

  axios.get("/v1/categories")
  .then((res) => {
    setMainCatData(res.data)
    setIsLoader(false)
  })
  .catch((err) => {
    dispatch(setSnackbar(true,'error',err.response.data.error))
    console.log(err)
    setIsLoader(false)
  })
}
const getSubCatData = () => {
  setIsLoader(true)

  axios.get("/v1/subcategories")
  .then((res) => {
    setSubCatData(res.data)
    setIsLoader(false)
  })
  .catch((err) => {
    console.log(err)
    dispatch(setSnackbar(true,'error',err.response.data.error))
    setIsLoader(false)
  })
}
const getUomData = () => {
  setIsLoader(true)

  axios.get("/v1/units")
  .then((res) => {
    setUomCatData(res.data)
    setIsLoader(false)
  })
  .catch((err) => {
    dispatch(setSnackbar(true,'error',err.response.data.error))
    console.log(err)
    setIsLoader(false)
  })
}
const getCustomerData = () => {
  setIsLoader(true)

  axios.get("/v1/supplier")
  .then((res) => {
    setCusData(res.data)
    setIsLoader(false)
  })
  .catch((err) => {
    dispatch(setSnackbar(true,'error',err.response.data.error))
    console.log(err)
    setIsLoader(false)
  })
}
    const getItemsData = () =>{
  setIsLoader(true)
      const url = `/v1/Item/${rowsPerPage}/${page + 1}`
      const searchUrl = `/v1/Item/${rowsPerPage}/${page + 1}/${search}`
      axios.get(search === '' ? url : searchUrl)
          .then(res=>{
            setData(res.data.data)
            setPageCount(res.data.meta.pagination.total)
            setIsLoader(false)
          })
          .catch(err=>{
            console.log(err)
            dispatch(setSnackbar(true, 'error', err.response.data.errors[0].message))
            setIsLoader(false)
          })
        }
             // Handle changes in any TextField (stock values)
             const handleInputChange = (e) => {
              const { name, value } = e.target;
              setNewData((prevData) => ({
                ...prevData,
                [name]: value,
              }));
            };
          
            // Handle switch changes
            const handleSwitchChange = (e) => {
              const { name, checked } = e.target;
              setNewData((prevData) => ({
                ...prevData,
                [name]: checked,
              }));
            };
    const columns = [
        {
          field: "sno",
          headerName: "S.no",
          flex: 1,
          minWidth: 70,
          maxWidth: 100,
          headerAlign: "center",
          align: "center",
          sortable: false,
        },
        {
          field: "productCode",
          headerName: "Product Code",
          minWidth: 200,
          headerAlign: "left",
          align: "left",
          sortable: false,
        },
        {
          field: "shortName",
          headerName: "Short Name",
          minWidth: 200,
          headerAlign: "left",
          align: "left",
          sortable: false,
        },
        {
          field: "productName",
          headerName: "Product Name",
          minWidth: 200,
          headerAlign: "left",
          align: "left",
          sortable: false,
          headerClassName: 'bold-header',
        },
        {
          field: "productDisc",
          headerName: "Product Discription",
          minWidth: 200,
          headerAlign: "left",
          align: "left",
          sortable: false,
          headerClassName: 'bold-header',
        },
        {
          field: "typeDesign_name",
          headerName: "Type",
          minWidth: 200,
          headerAlign: "left",
          align: "left",
          sortable: false,
          headerClassName: 'bold-header',
        },
        {
          field: "head_name",
          headerName: "Brand Name",
          minWidth: 200,
          headerAlign: "left",
          align: "left",
          sortable: false,
          headerClassName: 'bold-header',
        },
        {
          field: "category_name",
          headerName: "Category Name",
          minWidth: 200,
          headerAlign: "left",
          align: "left",
          sortable: false,
          headerClassName: 'bold-header',
        },
        {
          field: "subCategory_name",
          headerName: "Subcategory Name",
          minWidth: 200,
          headerAlign: "left",
          align: "left",
          sortable: false,
          headerClassName: 'bold-header',
        },
        {
          field: "uom_name",
          headerName: "Uom Name",
          minWidth: 200,
          headerAlign: "left",
          align: "left",
          sortable: false,
          headerClassName: 'bold-header',
        },
        {
          field: "op_stk",
          headerName: "Op Stock",
          minWidth: 200,
          headerAlign: "left",
          align: "left",
          sortable: false,
          headerClassName: 'bold-header',
        },
        {
          field: "min_stock",
          headerName: "Min Stock",
          minWidth: 200,
          headerAlign: "left",
          align: "left",
          sortable: false,
          headerClassName: 'bold-header',
        },
        {
          field: "manufactureDate",
          headerName: "Manufacture Date",
          minWidth: 200,
          headerAlign: "left",
          align: "left",
          sortable: false,
          headerClassName: 'bold-header',
        },
        {
          field: "expiryDate",
          headerName: "Expiry Date",
          minWidth: 200,
          headerAlign: "left",
          align: "left",
          sortable: false,
          headerClassName: 'bold-header',
        },
        {
          field: 'action',
          headerName: 'Action',
          headerClassName: 'bold-header',
          minWidth: 100,
          headerAlign: "center",
          align: "center",
          editable: false,
          sortable: false,
          disableExport: true ,
          disableColumnMenu: true,
          renderCell: (params) => (
            <div className='flex justify-center w-full'>
              <IconButton onClick={()=>onEdit(params.row)} >
                <EditNoteIcon sx={{color:"#1972d2",fontSize:22}}/>
              </IconButton>
              <IconButton onClick={() => OnDelete(params.id)}>
                <DeleteIcon sx={{color:"red",fontSize:22}}/>
              </IconButton>
            </div>
          ),
        },
      ];
    
      const rows = _.map(data, (val , idx) => ({
        id:val.id,
        sno: ++idx,
        balance:val.balance,
        productCode:val.pro_code,
        productName:val.pro_name ,
        typeDesign_id:val.type,
        typeDesign_name:val.type_name,
        head_id:val.head_id,
        head_name:val.head_name,
        category_id:val.cat_id,
        category_name:val.cat_name,
        subCategory_id:val.sub_cat,
        subCategory_name:val.sub_cat_name,
        uom_id:val.uom,
        uom_name:val.uom_name,
        barCode:val.barcode,
        purchaseRate:val.pur_rate,
        wholeSaleRate:val.wholesale_rate,
        salesRate:val.sale_rate,
        mrp:val.mrp,
        gst:val.gst,
        cess:val.cess,
        hsn:val.hsn,
        op_stk:val.op_stk,
        min_stock:val.min_stock,
        wScale:val.wscale,
        is_batch:val.is_batch,
        vendor:val.vendors,
        allow_neg_stock:val.allow_neg_stk,
        outlets: val.outlets,
        shortName:val.short_name || "-",
        productDisc:val.pro_description || "-",
        manufactureDate:val.manufacturing_date != null ? moment(val.manufacturing_date).format("DD-MM-YYYY") : "-",
        manufacturing_date:moment(val.manufacturing_date).format("YYYY-MM-DD"),
        expiryDate:val.expiry_date != null ? moment(val.expiry_date).format("DD-MM-YYYY") : "-",
        expiry_date:moment(val.expiry_date).format("YYYY-MM-DD")
      }))

      const props = {
        rows : rows,
        columns : columns,
        search : search,
        setSearch: setSearch,
        page: page,
        setPage : setPage,
        rowsPerPage : rowsPerPage,
        setRowsPerPage : setRowsPerPage,
        pageCount : pageCount,
        pageOption : pageOption
      }

const getOutletData = () =>{
  setIsLoader(true)

  axios.get('/v1/outlet/list/1')
  .then(res=>{
    setOutletData(res.data)
  setIsLoader(false)
  })
  .catch(err=>{
    dispatch(setSnackbar(true, 'error', err.response.data.errors[0].message))
    setIsLoader(false)
  })
}
// const fetchTypeDesigns = async () => {
//   try {
//     const response = await axios.get('/v1/typedesign'); // Adjust the API endpoint as necessary
//     setTypeData(response.data); // Update the state with the fetched data
//   } catch (error) {
//     console.error('Error fetching type designs:', error);
//   }
// };

 // Function to fetch outlet data
 const getfromOutletData = () =>{
  setIsLoader(true)

  axios.get('/v1/outlet/to/outlet/transfer/existing')
  .then(res=>{
    setOutletData1(res.data)

  setIsLoader(false)
  console.log(res.data,"responseres");
  
  })
  .catch(err=>{
    dispatch(setSnackbar(true, 'error', err.response.data.errors[0].message))
    setIsLoader(false)
  })
}
 const gettoOutletData = () =>{
  setIsLoader(true)

  axios.get('/v1/outlet/to/outlet/transfer/new')
  .then(res=>{
    setOutletToData(res.data)
  setIsLoader(false)
  console.log(res.data,"gettoOutletData");
  
  })
  .catch(err=>{
    // dispatch(setSnackbar(true, 'error', err.response.data.errors[0].message))
    setIsLoader(false)
  })
}

useEffect(() => {
  getfromOutletData()
  gettoOutletData()
}, []);

const handleClone = async () => {

  const cloneData = {
    from_outlet: fromOutlet.outlet_id, // Ensure this exists
    to_outlet: toOutlet.id,     // Ensure this exists
  };

  try {
    const res = await axios.post('/v1/outlet/to/outlet/transfer', cloneData);
    dispatch(setSnackbar(true, 'success','Product Mapping Successfully!'))
    setIsLoader(false);
  } catch (err) {
    const errorMessage = err.response?.data?.errors?.[0]?.message || 'An error occurred';
    dispatch(setSnackbar(true, 'error', errorMessage));
    setIsLoader(false);
  }
};


      useEffect(()=>{
        getItemsData()
      },[rowsPerPage, page, search,prodDate])

      useEffect(() => {
        getTypeDesignData()
        getHeadData()
        getMainCatData()
        getSubCatData()
        getUomData()
        getCustomerData()
        getOutletData()
      },[])

      useEffect(()=>{
        console.log('Vanthuden')
        // axios.get('http://girlush-scmapi-uat.bluekode.com/v1/outlet_sales_master/29')
        if( formik.values.mrp!=="" && formik.values.gst!==""){
          console.log('ulla vanthuden', (100 + formik.values.gst))
          formik.setFieldValue('salesRate', parseFloat( formik.values.mrp * 100 / (100 + Number(formik.values.gst))).toFixed(2))
        }
      },[formik.values,prodDate])

      const outletOptions = outletData.length > 0 ? [{ id: 'all', fullname: 'All' }, ...outletData] : outletData;

  return (
    <>
   <Grid className='' >
    <Helmet>
      <title>Products</title>
    </Helmet>
 <div className='flex justify-between'>
      <Typography variant='h5'>Product List</Typography>
      {/* <div className='flex items-center my-3'>
      <Typography>Balance</Typography>
      <Typography sx={{width:"100px",height:"40px",backgroundColor:"#7b068f",marginLeft:"10px",color:"#fff",display:"flex",alignItems:"center",justifyContent:"center"}}>200 Rs</Typography>
      </div> */}
    </div>
{!open &&
  <Grid className='flex justify-end'>
    <Button variant='contained' size='small' onClick={onCreate}>Create New</Button>
</Grid>
}
{/* <PrintComponent /> */}
{open &&
<Modal onClose={setOpen} onSave={formik.handleSubmit} formik={formik} isEdit={isEdit}>
  <div style={{textAlign:"right"}}>
<Button variant='outlined' onClick={() => setOpen(false)}>Close</Button>
  </div>
  
  <Grid container spacing={2}>
   
  <Grid item xs={12} >
        <Typography fontSize={16} fontWeight={600} color={"#A06EE1"}>1. Product Details</Typography>
      </Grid>
      <Grid item xs={12} sm={6} md={4} lg={3}>
      <Typography variant="body1" fontSize={17} style={{ paddingBottom: '8px' }}>Product Code</Typography>
    {/* <TextField size="small" fullWidth id="productCode" value={formik.values.productCode} title="Product Code" multiple={false} placeholder="Enter product Code" onchange={formik.handleChange} onKeyPress={handleEnterKey} errorMsg={ formik.touched.productCode &&  Boolean(formik.errors.productCode) } helperText={formik.touched.productCode && formik.errors.productCode}/> */}
    <TextField
  size="small"
  fullWidth
  id="productCode"
  value={formik.values.productCode}
  title="Product Code"
  placeholder="Enter product Code"
  onChange={formik.handleChange} // Corrected here
  onKeyPress={handleEnterKey}
  error={formik.touched.productCode && Boolean(formik.errors.productCode)} // Corrected here
  helperText={formik.touched.productCode && formik.errors.productCode}
/>

    </Grid>
    <Grid item xs={12} sm={6} md={4} lg={3}>
    <CustomTextField id="shortName" value={formik.values.shortName} title="Short Name" multiple={false} placeholder="Enter Short name" onchange={formik.handleChange} errorMsg={ formik.touched.shortName &&  Boolean(formik.errors.shortName) } helperText={formik.touched.shortName && formik.errors.shortName}/>
    </Grid>
    <Grid item xs={12} sm={6} md={4} lg={3}>
    <CustomTextField id="productName" value={formik.values.productName} title="Product Name" multiple={false} placeholder="Enter product name" onchange={formik.handleChange} errorMsg={ formik.touched.productName &&  Boolean(formik.errors.productName) } helperText={formik.touched.productName && formik.errors.productName}/>
    </Grid>
    <Grid item xs={12} sm={6} md={4} lg={3}>
    <CustomTextField id="productDisc" value={formik.values.productDisc} title="Product Discription" multiple={false} placeholder="Enter product Discription" onchange={formik.handleChange} errorMsg={ formik.touched.productDisc &&  Boolean(formik.errors.productDisc) } helperText={formik.touched.productDisc && formik.errors.productDisc}/>
    </Grid>
    <Grid item xs={12} sm={6} md={4} lg={3} >
    <Box display="flex" alignItems="center" mb={0.8}>
  <Typography variant="body1" fontSize={17}>
  Brand
  </Typography>
      <Add sx={{ ml: 1, cursor: 'pointer' }} onClick={OnclickBrandDesign}/>

</Box>
<Autocomplete
  id="head"
      size='small'
  options={headData}  // The data array for the dropdown options
  getOptionLabel={(option) => option.cateogory_name}  // Display label for each option
  value={formik.values.head}  // Value from formik
  onChange={(e, value) => {
    formik.setFieldValue("head", value);
  }}
  onOpen={getHeadData}  // Trigger API call when the dropdown is opened
  isOptionEqualToValue={(option, value) => option.cateogory_name === value?.cateogory_name}  // Match the option with the selected value
  renderInput={(params) => (
    <TextField
      {...params}
     
      placeholder="Select Brand"
      error={formik.touched.head && Boolean(formik.errors.head)}  // Error state
      helperText={formik.touched.head && formik.errors.head}  // Error message
    />
  )}
/>
    
    </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3} >
        <Box display="flex" alignItems="center" mb={0.8}>
  <Typography variant="body1" fontSize={17}>
  Main Category
  </Typography>
      <Add sx={{ ml: 1, cursor: 'pointer' }} onClick={OnclickMainCatecory}/>

</Box>

          <Autocomplete
  id="mainCategory"
  size='small'
  options={mainCatData}  // The data array for main category options
  getOptionLabel={(option) => option.category_name}  // Display label for each option
  value={formik.values.mainCategory}  // Value from formik
  onChange={(e, value) => {
    formik.setFieldValue("mainCategory", value);
  }}
  onOpen={getMainCatData}
  isOptionEqualToValue={(option, value) => option.category_name === value?.category_name}  // Match the option with the selected value
  renderInput={(params) => (
    <TextField
      {...params}
      // label="Main Category"  // Label for the autocomplete input
      placeholder="Select Main Category"
      error={formik.touched.mainCategory && Boolean(formik.errors.mainCategory)}  // Error state
      helperText={formik.touched.mainCategory && formik.errors.mainCategory}  // Error message
    />
  )}
/>
    </Grid>
    <Grid item xs={12} sm={6} md={4} lg={3} >
    <Box display="flex" alignItems="center" mb={0.8}>
  <Typography variant="body1" fontSize={17}>
  Sub Category
  </Typography>
      <Add sx={{ ml: 1, cursor: 'pointer' }} onClick={OnclickSubCatecory}/>

</Box>
<Autocomplete
  id="subCategory"
    size='small'
  options={subCatData }  // The data array for subcategory options
  getOptionLabel={(option) => option.subcategory_name}  // Display label for each option
  value={formik.values.subCategory}  // Value from formik
  onChange={(e, value) => {
    formik.setFieldValue("subCategory", value);
  }}
  onOpen={getSubCatData}
  isOptionEqualToValue={(option, value) => option.subcategory_name === value?.subcategory_name}  // Match the option with the selected value
  renderInput={(params) => (
    <TextField
      {...params}
      placeholder="Select Sub Category"
      error={formik.touched.subCategory && Boolean(formik.errors.subCategory)}  // Error state
      helperText={formik.touched.subCategory && formik.errors.subCategory}  // Error message
    />
  )}
/>
    </Grid>

       <Grid item xs={12} sm={6} md={4} lg={3} >

       {/* <Typography variant='body1' fontSize={17}  mb={0.8} >Type Design </Typography> */}

  <Box display="flex" alignItems="center" mb={0.8}>
  <Typography variant="body1" fontSize={17}>
    Type Design
  </Typography>
      <Add sx={{ ml: 1, cursor: 'pointer' }} onClick={OnclicktypeDesign}/>

</Box>
<Autocomplete
      id='typeDesign'
      name='typeDesign'
      size='small'
      options={typeData}
      getOptionLabel={(option) => option.type_name}
      value={formik.values.typeDesign}
      onChange={(e, value) => formik.setFieldValue('typeDesign', value)}
      onOpen={getTypeDesignData} // Call fetchTypeDesigns when dropdown is opened
      fullWidth
      isOptionEqualToValue={(option, value) => option.type_name === value.type_name}
      renderInput={(params) => (
        <TextField
          {...params}
          autoComplete='off'
          placeholder='Select Type Design'
          error={formik.touched.typeDesign && Boolean(formik.errors.typeDesign)}
          helperText={formik.touched.typeDesign && formik.errors.typeDesign}
        />
      )}
    />
  </Grid>

    <Grid item xs={12} sm={6} md={4} lg={3} >
    <CustomdropDown
          id="uom"
          data={uomData}
          optionLabel={(option) => option.units_long_name}
          
          value={formik.values.uom}
          onchange={(e, value) => {
            formik.setFieldValue("uom", value);
          }}
          optionEqual={(option, value) => option.units_long_name === value.units_long_name}
          placeholder="Select uom"
          helperText={formik.touched.uom && formik.errors.uom}
          errorMsg={
              formik.touched.uom && Boolean(formik.errors.uom)
          }
          title="UOM"
          />
    </Grid>
    {/* <Grid item xs={12} sm={6} md={4} lg={3} >
    <CustomTextField id="barcode" value={formik.values.barcode} title="Barcode" multiple={false} placeholder="Enter barcode" onchange={formik.handleChange} errorMsg={ formik.touched.barcode &&  Boolean(formik.errors.barcode) } helperText={formik.touched.barcode && formik.errors.barcode}/>
    </Grid> */}
    <Divider />
    <Grid item xs={12} >
        <Typography fontSize={16} fontWeight={600} color={"#A06EE1"}>2. Cost Details</Typography>
      </Grid>
    <Grid item xs={12} sm={6} md={4} lg={3} >
    <CustomTextField id="purchaseRate" value={formik.values.purchaseRate} title="Purchase Rate" multiple={false} placeholder="Enter purchase rate" onchange={formik.handleChange} errorMsg={ formik.touched.purchaseRate &&  Boolean(formik.errors.purchaseRate) } helperText={formik.touched.purchaseRate && formik.errors.purchaseRate}/>
    </Grid>
    <Grid item xs={12} sm={6} md={4} lg={3}>
    <Typography variant='body1' fontSize={17} mb={0.8}>Sales Rate</Typography>
    <TextField fullWidth size='small' id="salesRate" value={formik.values.salesRate} placeholder="Enter sales rate" error={formik.touched.salesRate &&  Boolean(formik.errors.salesRate)} helperText={formik.touched.salesRate && formik.errors.salesRate} InputProps={{readOnly: true,}}/>
    </Grid>
    <Grid item xs={12} sm={6} md={4} lg={3}>
    <CustomTextField id="wholeSaleRate" value={formik.values.wholeSaleRate} title="Wholesale Rate" multiple={false} placeholder="Enter wholesale rate" onchange={formik.handleChange} errorMsg={ formik.touched.wholeSaleRate &&  Boolean(formik.errors.wholeSaleRate) } helperText={formik.touched.wholeSaleRate && formik.errors.wholeSaleRate}/>
    </Grid>
    <Grid item xs={12} sm={6} md={4} lg={3} >
    <CustomTextField id="mrp" value={formik.values.mrp} title="MRP" multiple={false} placeholder="Enter mrp" onchange={formik.handleChange} errorMsg={ formik.touched.mrp &&  Boolean(formik.errors.mrp) } helperText={formik.touched.mrp && formik.errors.mrp}/>
    </Grid>
    <Divider />
    <Grid item xs={12} >
        <Typography fontSize={16} fontWeight={600} color={"#A06EE1"}>3. GST / HSN Details</Typography>
      </Grid>
    <Grid item xs={12} sm={6} md={4} lg={3}>
    <CustomTextField id="gst" value={formik.values.gst} title="GST" multiple={false} placeholder="Enter gst" onchange={formik.handleChange} errorMsg={ formik.touched.gst &&  Boolean(formik.errors.gst) } helperText={formik.touched.gst && formik.errors.gst}/>
    </Grid>
    <Grid item xs={12} sm={6} md={4} lg={3} >
    <CustomTextField id="cess" value={formik.values.cess} title="CESS" multiple={false} placeholder="Enter cess" onchange={formik.handleChange} errorMsg={ formik.touched.cess &&  Boolean(formik.errors.cess) } helperText={formik.touched.cess && formik.errors.cess}/>
    </Grid>
    <Grid item xs={12} sm={6} md={4} lg={3}>
    <CustomTextField id="hsn" value={formik.values.hsn} title="HSN" multiple={false} placeholder="Enter hsn" onchange={formik.handleChange} errorMsg={ formik.touched.hsn &&  Boolean(formik.errors.hsn) } helperText={formik.touched.hsn && formik.errors.hsn}/>
    </Grid>
    <Divider />
    <Grid item xs={12} >
        <Typography fontSize={16} fontWeight={600} color={"#A06EE1"}>4. Stock Details</Typography>
      </Grid>
    <Grid item xs={12} sm={6} md={4} lg={3}>
    <CustomTextField id="opStk" value={formik.values.opStk} title="OP STOCK" multiple={false} placeholder="Enter wholesale rate" onchange={formik.handleChange} errorMsg={ formik.touched.opStk &&  Boolean(formik.errors.opStk) } helperText={formik.touched.opStk && formik.errors.opStk}/>
    </Grid>
    <Grid item xs={12} sm={6} md={4} lg={3} >
    <CustomTextField id="minStk" value={formik.values.minStk} title="Min Stock" multiple={false} placeholder="Enter min stock" onchange={formik.handleChange} errorMsg={ formik.touched.minStk &&  Boolean(formik.errors.minStk) } helperText={formik.touched.minStk && formik.errors.minStk}/>
    </Grid>
    <Grid item xs={12}  md={4} lg={3} >
  <Typography variant="body1" my={1}> Allow Neg Stock</Typography>
    <FormControl sx={{ display: "flex" }}>
      <RadioGroup
        aria-labelledby="demo-radio-buttons-group-label"
        name="allowNegStack"
        id="allowNegStack"
        sx={{ flexDirection: "row", display: "flex" }}
        onChange={formik.handleChange}
      >
        <FormControlLabel
          value="Yes"
          control={<Radio size="small" checked={formik.values.allowNegStack==='Yes'} />}
          label="yes"
        />
        <FormControlLabel
          value="No"
          control={<Radio size="small"  checked={formik.values.allowNegStack==='No'}/>}
          label="No"
        />
      </RadioGroup>
      <Typography sx={{color:"red",fontSize:12}}>{formik.touched.allowNegStack && formik.errors.allowNegStack}</Typography>
    </FormControl>
  </Grid>

     <Grid item xs={12}  md={4} lg={3} >
  <Typography variant="body1" my={1}>Wscale</Typography>
    <FormControl sx={{ display: "flex" }} >
      <RadioGroup
        aria-labelledby="demo-radio-buttons-group-label"
        name="wScale"
        id="wScale"
        sx={{ flexDirection: "row", display: "flex" }}
        onChange={formik.handleChange}
      >
        <FormControlLabel
          value="Yes"
          control={<Radio size="small" checked={formik.values.wScale==='Yes'} />}
          label="yes"
        />
        <FormControlLabel
          value="No"
          control={<Radio size="small"  checked={formik.values.wScale==='No'}/>}
          label="No"
        />
      </RadioGroup>
      <Typography sx={{color:"red",fontSize:12}}>{formik.touched.wScale && formik.errors.wScale}</Typography>
    </FormControl>
  </Grid>

    <Grid item xs={12} md={4} lg={3} >
    <Typography variant='body1' fontSize={17}  mb={0.8}>Vendor</Typography>
    <Autocomplete 
        id='vendor'
        name='vendor'
        size='small'
        options={cusData}
        getOptionLabel={(option)=>option.name}
        value={formik.values.vendor}
        onChange={(e,value)=>  formik.setFieldValue("vendor", value)}
        fullWidth
        multiple={true}
        limitTags={3}
        isOptionEqualToValue={(option, value)=>option.name=== value.name}
        renderInput={(params)=>(
          <TextField 
          {...params}
          autoComplete='off'
          placeholder='Select Vendor'
          error={formik.touched.vendor && Boolean(formik.errors.vendor)}
          helperText={formik.touched.vendor && formik.errors.vendor}
          />
        )}
        />

    </Grid>
    {isEdit &&       <Grid item xs={12} md={4} lg={3}>
      <Typography variant='body1' fontSize={20} fontWeight={600} mb={0.8} >Balance : {balance}</Typography>
    </Grid>}
    <Grid item xs={12} >
        <Typography fontSize={16} fontWeight={600} color={"#A06EE1"}>5. Outlet Mapping</Typography>
      </Grid>
      <Grid item xs={12} md={4} lg={4} >
        <Autocomplete
        id='outlet'
        name='outlet'
        size='small'
        options={outletOptions}
        getOptionLabel={(options)=>options.fullname}
        value={formik.values.outlet}
        onChange={(e, value, reason, details) => {
          if (details?.option?.id === 'all') {
            const allNowSelected = formik.values.outlet.length !== outletData.length;
            formik.setFieldValue('outlet', allNowSelected ? outletData : []);
          } else {
            formik.setFieldValue('outlet', value.filter(v => v.id !== 'all'));
          }
        }}
        fullWidth
        multiple={true}
        disableCloseOnSelect
        renderOption={(props, option, { selected }) => {
          const isAllOption = option.id === 'all';
          const isChecked = isAllOption
            ? outletData.length > 0 && formik.values.outlet.length === outletData.length
            : selected;
          return (
            <li {...props} key={isAllOption ? 'all' : option.id}>
              <Checkbox
                icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                checkedIcon={<CheckBoxIcon fontSize="small" />}
                checked={isChecked}
                style={{ marginRight: 8 }}
              />
              {option.fullname}
            </li>
          );
        }}
        sx={{
          '& .MuiOutlinedInput-root': {
            maxHeight: 320,
            alignItems: 'flex-start',
            overflowY: 'auto',
          },
        }}
        isOptionEqualToValue={(option, value)=>option.fullname=== value.fullname}
        renderInput={(params)=>(
          <TextField 
          {...params}
          autoComplete='off'
          placeholder='Select Outlet'
          error={formik.touched.outlet && Boolean(formik.errors.outlet)}
          helperText={formik.touched.outlet && formik.errors.outlet}
          />
        )}
        />
              
    </Grid>
    <Grid item xs={12} md={6} lg={8} >

<TableContainer component={Paper} sx={{ maxHeight: "320px !important", overflow: "auto" ,zIndex: 1}}>
  <Table stickyHeader
    sx={{
      '& .MuiTableCell-root': {
        padding: 1,
        fontSize:12,
      },
    }}
  >
    <TableHead className={classes.tblHeader} sx={{ position: "sticky", top: 0, zIndex: 1 ,}}>
      <TableRow>
        <TableCell>Full Name</TableCell>
        <TableCell>OP STOCK</TableCell>
        <TableCell>Bal Stock</TableCell>
        <TableCell>Min Stock</TableCell>
        <TableCell>Allow Neg Stock</TableCell>
        <TableCell>Wscale</TableCell>
      </TableRow>
    </TableHead>
    <TableBody>
      {formik.values.outlet.map((outlet, index) => (
        <TableRow key={index}>
          <TableCell  style={{width:"100px"}}>{outlet.fullname}</TableCell>
          <TableCell>
            <TextField
              style={{width:"100px"}}
              variant="outlined"
              size="small"
              // type="number"
              name={`outlet_${index}_op_stock`}  // Unique name for each outlet's OP Stock
              value={newData[`outlet_${index}_op_stock`] || ""}  // Use newData for value
              onChange={(e) => handleInputChange(e, index)} // Modify for index
            //    disabled={
            //   isEdit === true &&
            //   parseFloat(newData[`outlet_${index}_op_stock`]) > 0
            // }
              InputProps={{
                sx: {
                  '& input': {
                    padding: '4px',
                  },
                },
              }}
           />
          </TableCell>
          <TableCell>
            <TextField
             style={{width:"100px"}}

              variant="outlined"
              size="small"
              // type="number"
              name={`outlet_${index}_bal_stock`}  // Unique name for each outlet's Bal Stock
              value={newData[`outlet_${index}_bal_stock`] || ""}  // Use newData for value
              onChange={(e) => handleInputChange(e, index)} // Modify for index
            //     disabled={
            //   isEdit === true &&
            //   parseFloat(newData[`outlet_${index}_bal_stock`]) > 0
            // }
              InputProps={{
                sx: {
                  '& input': {
                    padding: '4px',
                  },
                },
              }}
           />
          </TableCell>
          <TableCell>
            <TextField
            style={{width:"100px"}}

              variant="outlined"
              size="small"
              // type="number"
              name={`outlet_${index}_min_stock`}  // Unique name for each outlet's Min Stock
              value={newData[`outlet_${index}_min_stock`] || ""}  // Use newData for value
              onChange={(e) => handleInputChange(e, index)} // Modify for index
              InputProps={{
                sx: {
                  '& input': {
                    padding: '4px',
                  },
                },
              }}
          />
          </TableCell>
          <TableCell>
            <Switch 
              checked={newData[`outlet_${index}_allow_neg_stk`] || false}  // Use newData for Switch value
              onChange={(e) => handleSwitchChange(e, index)} // Modify for index
              name={`outlet_${index}_allow_neg_stk`}  // Unique name for each outlet's Switch
              color="primary"
            />
          </TableCell>
          <TableCell>
            <Switch
              checked={newData[`outlet_${index}_wscale`] || false}  // Use newData for Switch value
              onChange={(e) => handleSwitchChange(e, index)} // Modify for index
              name={`outlet_${index}_wscale`}  // Unique name for each outlet's Switch
              color="primary"
            />
          </TableCell>
        </TableRow>
      ))}
    </TableBody>
  </Table>
</TableContainer>
          </Grid>
    <Grid item xs={12} >
        <Typography fontSize={16} fontWeight={600} color={"#A06EE1"}>6. Product Information</Typography>
      </Grid>
      <Grid item xs={12} md={4} lg={3} >
      <Typography>Manufacture Date</Typography>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              onChange={(e) => handleChange(e, "manufactureDate")}
              value={dayjs(prodDate.manufactureDate)}
              format="DD-MM-YYYY"
              slotProps={{
                textField: {
                  size: "small",
                  // label:'Manufacture Date',
                  style:{width : '100%',marginBlock:2}
                },
              }}
            />
          </LocalizationProvider>
      </Grid>
      <Grid item xs={12} md={4} lg={3} >
        <Typography>Expiry Date</Typography>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              onChange={(date) => handleChange(date, "expiryDate")}
              value={dayjs(prodDate.expiryDate)}
              format="DD-MM-YYYY"
              slotProps={{
                textField: {
                  size: "small",
                  // label:'Expiry Date',
                  style:{width : '100%',marginBlock:2}
                },
              }}
            />
          </LocalizationProvider>
      </Grid>
      
     <Grid item xs={12}  md={4} lg={3} >
  <Typography variant="body1" my={1}>Is Expiry ?</Typography>
    <FormControl sx={{ display: "flex" }} >
      <RadioGroup
        aria-labelledby="demo-radio-buttons-group-label"
        name="isBatch"
        id="isBatch"
        sx={{ flexDirection: "row", display: "flex" }}
        onChange={formik.handleChange}
      >
        <FormControlLabel
          value="Yes"
          control={<Radio size="small" checked={formik.values.isBatch==='Yes'} />}
          label="yes"
        />
        <FormControlLabel
          value="No"
          control={<Radio size="small"  checked={formik.values.isBatch==='No'}/>}
          label="No"
        />
      </RadioGroup>
      <Typography sx={{color:"red",fontSize:12}}>{formik.touched.isBatch && formik.errors.isBatch}</Typography>
    </FormControl>
  </Grid>
      {/* <Grid item xs={12} >
        <Typography fontSize={16} fontWeight={600} color={"#A06EE1"}>7. Product Mapping</Typography>
      </Grid>

      <Grid item xs={12}  md={4} lg={3}>
        <Box display="flex" alignItems="center" mb={0.8}>
          <Typography variant="body1" fontSize={17}>
            From Outlet
          </Typography>
        </Box>
        <Autocomplete
          id="fromoutlet"
          size='small'
          options={outletData1}
          getOptionLabel={(option) => option.fullname} // Adjust based on your outlet data structure
          value={fromOutlet}
          onChange={(e, value) => {
            setFromOutlet(value); // Set from outlet state
          }}
          isOptionEqualToValue={(option, value) => option.id === value?.id} // Match based on ID
          renderInput={(params) => (
            <TextField
              {...params}
              placeholder="Select From Outlet"
              error={formik.touched.fromoutlet && Boolean(formik.errors.fromoutlet)}
              helperText={formik.touched.fromoutlet && formik.errors.fromoutlet}
            />
          )}
        />
      </Grid>

      <Grid item xs={12}  md={4} lg={3}>
        <Box display="flex" alignItems="center" mb={0.8}>
          <Typography variant="body1" fontSize={17}>
            To Outlet
          </Typography>
        </Box>
        <Autocomplete
          id="tooutlet"
          size='small'
          options={outletToData}
          getOptionLabel={(option) => option.fullname} // Adjust based on your outlet data structure
          value={toOutlet}
          onChange={(e, value) => {
            setToOutlet(value); // Set to outlet state
          }}
          isOptionEqualToValue={(option, value) => option.id === value?.id} // Match based on ID
          renderInput={(params) => (
            <TextField
              {...params}
              placeholder="Select To Outlet"
              error={formik.touched.tooutlet && Boolean(formik.errors.tooutlet)}
              helperText={formik.touched.tooutlet && formik.errors.tooutlet}
            />
          )}
        />
        
      </Grid>

      <Grid item xs={12}  md={4} lg={3}>
        <Box display="flex" alignItems="center" mt={4} >
          <Button variant='contained' size='small' onClick={handleClone}>CLONE</Button>
        </Box>
      </Grid> */}
 
  </Grid>
</Modal>
}
<Grid className='bg-white rounded-md p-2 my-3'>
                {/* <Button 
                variant='contained' size='small' 
                sx={{
                  fontSize: 20,      
              }}
                onClick={() => OnAssignProduct()}>
                    Assign Product
                </Button> */}
<Box position="relative" width="100%">
<CustomDataGrid props={props} OnAssignProduct={OnAssignProduct}/>
{isLoader && (
  <Box
    display="flex"
    justifyContent="center"
    alignItems="center"
    position="absolute"
    top={0}
    left={0}
    right={0}
    bottom={0}
    bgcolor="rgba(255, 255, 255, 0.7)"
    zIndex={1}
  >
    <CircularProgress size={50} />
  </Box>
)}
</Box>
</Grid>
<Backdrop open={openDialog} sx={{zIndex:1350}}>
  <DeletePage onCancel={setOpenDialog} onSubmit={handleDelete}/>
</Backdrop>

   </Grid>
   <Backdrop open={opentypedesign} sx={{zIndex:1350}}>
   <TypeDesignModal onCancel={setOpenTypeDesign}/>
 </Backdrop>
   <Backdrop open={opentypedesign1} sx={{zIndex:1350}}>
   <BrandModal onCancel={setOpenTypeDesign1}/>
 </Backdrop>
   <Backdrop open={openMainCategory} sx={{zIndex:1350}}>
   <MainCategoryModal onCancel={setOpenMainCategory}/>
 </Backdrop>

   <Backdrop open={openSubCategory} sx={{zIndex:1300}}>
   <SubCategoryModal onCancel={setOpenSubCategory}/>
 </Backdrop>
 <Backdrop open={openProduct} sx={{zIndex:1050}}>
  {/* <ProductMapping onCancel={setOpenProduct}   onSubmit={OnAssignProduct}

  /> */}

    <ProductMapping 
    onCancel={setOpenProduct}   onSubmit={OnAssignProduct} 
    fromOutlet={selectedOutlet} outletId={selectedOutletId} selectedOutletName={selectedOutletName}setSelectedOutletName={setSelectedOutletName}
    />

</Backdrop>
 </>
  )
}

export default Product